import React from "react";
import { useNavigate } from "react-router-dom";
import Footer from "./Footer";
import { SignOutMockup, AttendanceMockup, EmergencyMockup } from "./Mockups";
import "./landing.css";

const features = [
  {
    title: "Attendance",
    description:
      "Students click their name to mark their arrival — their name leaves the list and the system logs the exact time they showed up. Roll call becomes effortless, and you keep a precise, automatic record of who's present every day.",
    Mock: AttendanceMockup,
  },
  {
    title: "Sign Out",
    description:
      "Students sign out of the classroom with their name or class. Every trip is time-stamped and attributed to the right room and teacher, so during a fire alarm or any emergency you know exactly where each student is.",
    Mock: SignOutMockup,
  },
  {
    title: "Emergency Checklist",
    description:
      "Use the checklist for fast accountability — emergency drills, field trips, or any time you need to confirm every student is accounted for. Trigger it school-wide and watch the counts update in real time from any classroom.",
    Mock: EmergencyMockup,
  },
];

const About = () => {
  const navigate = useNavigate();

  return (
    <div className="about">
      <header className="about-hero">
        <div className="landing-inner">
          <h1>About classBoon</h1>
          <p>
            A platform designed by a 5th-grade teacher to simplify classroom
            management. Our tools are intuitive, reliable, and built around the
            day-to-day needs of real teachers.
          </p>
        </div>
      </header>

      <div className="landing-inner">
        {features.map((feature, index) => {
          const { Mock } = feature;
          return (
            <React.Fragment key={feature.title}>
              <section className="about-feature">
                <div className="about-feature-text">
                  <h2>{feature.title}</h2>
                  <p>{feature.description}</p>
                </div>
                <div className="about-feature-img">
                  <Mock />
                </div>
              </section>
              {index < features.length - 1 && <div className="about-divider" />}
            </React.Fragment>
          );
        })}
      </div>

      <section className="landing-section landing-section--navy cta-band">
        <div className="landing-inner">
          <h2>Simplify your classroom today</h2>
          <p className="landing-lead">
            Your students' success, organized. Get started with classBoon in
            minutes — it's free.
          </p>
          <div className="cta-actions">
            <button
              className="landing-btn landing-btn--light"
              onClick={() => navigate("/register")}
            >
              Create a free account
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
